import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VisionServiceRequestDataService } from '../../../common/services/data-model/http/http-client-data/vision-service-request-data/vision-service-request-data.service';
import { VisionServiceRequest } from '../../../models/VisionServiceRequestResults';
import { DateUtility } from '../../../common/utility';
import {ApplicationConstants} from '../../../common/constants/application.constants';

@Component({
  selector: 'app-auth-details-report',
  templateUrl: './auth-details-report.component.html',
  styleUrls: ['./auth-details-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthDetailsReportComponent implements OnInit {
  private route = inject(ActivatedRoute);
  public authNumber: string;
  public vsrResponse: VisionServiceRequest;
  private lineItemSortOrder = ApplicationConstants.authDetailsReport.lineItemSortOrder;
  private criteriaSortOrder = ApplicationConstants.authDetailsReport.criteriaSortOrder;

  constructor(
    private visionServiceRequestDataService: VisionServiceRequestDataService,
  ) { }

  ngOnInit(): void {
    this.authNumber = this.route.snapshot.paramMap.get('authNumber');

    if (this.authNumber) {
      this.visionServiceRequestDataService.retrieveVisionServiceRequest(this.authNumber.trim()).subscribe((vsrResponse: VisionServiceRequest) => {
        this.vsrResponse = vsrResponse;
        this.vsrResponse.reifiedPatient.dateOfBirth = DateUtility.buildFriendlyDateFromJsDate(this.vsrResponse.reifiedPatient.dateOfBirth);
        this.vsrResponse.effectiveDate = DateUtility.buildFriendlyDateFromJsDate(this.vsrResponse.effectiveDate);
        this.vsrResponse.expirationDate = DateUtility.buildFriendlyDateFromJsDate(this.vsrResponse.expirationDate);
        if (this.vsrResponse?.reifiedEligibility?.authorizedItems) {
          this.vsrResponse.reifiedEligibility.authorizedItems = this.lineSorter(this.vsrResponse.reifiedEligibility.authorizedItems);
        }
        if (this.vsrResponse?.reifiedCoverage?.copaySummary) {
          this.vsrResponse.reifiedCoverage.copaySummary = this.lineSorter(this.vsrResponse.reifiedCoverage.copaySummary);
        }
        if (this.vsrResponse?.reifiedCoverage?.allowanceSummary) {
          this.vsrResponse.reifiedCoverage.allowanceSummary = this.lineSorter(this.vsrResponse.reifiedCoverage.allowanceSummary);
        }
      });
    }
  }

  private lineSorter(sortObject: any) {
    if (sortObject.length > 0) {
      sortObject.sort((a: any, b: any) => {
        let primaryA = this.lineItemSortOrder.indexOf(a.description);
        let primaryB = this.lineItemSortOrder.indexOf(b.description);

        if (primaryA === -1) primaryA = Infinity;
        if (primaryB === -1) primaryB = Infinity;

        const primaryDiff = primaryA - primaryB;
        if (primaryDiff !== 0 || (!a.criteria && !b.criteria)) {
          return primaryDiff;
        }

        let secondaryA = this.criteriaSortOrder.indexOf(a.criteria);
        let secondaryB = this.criteriaSortOrder.indexOf(b.criteria);
        if (secondaryA === -1) secondaryA = Infinity;
        if (secondaryB === -1) secondaryB = Infinity;

        return secondaryA - secondaryB;
      });
    }
    return sortObject;
  }

}
